__webpack_require__.p = "https://cdn-gs.retailanalysis.cloud/ui/2.28.1/";